export default __webpack_public_path__ + "static/media/hamburger.8c024507.svg";